'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Handles all things product related,
// Requires Neptune.cart to add to cart in Shopify

_neptune2.default.product = {

  init: function init(p) {

    p = p || document;

    _neptune2.default.products = _neptune2.default.products || [];

    _n3.default.qsa('[neptune-product]', p).forEach(function (el) {

      _n3.default.trigger(document, 'product:init', false, true, { el: el });

      el.instance = _n3.default.random(15);

      el.product = JSON.parse(el.getAttribute('neptune-product'));

      // find missing variants from possible options array and create them to fill in all options
      // _n.combine(el.product.options_with_values.map(o=>o.values)).map(o=>JSON.stringify(o)).filter(x => !el.product.variants.map(v=>{
      //   return JSON.stringify(v.options.reverse())
      // }).includes(x)).map(o=>{
      //   o = JSON.parse(o)
      //   console.log(o)
      //   el.product.variants.push(
      //     {
      //       id:0,
      //       price:el.product.variants[0].price,
      //       options:o,
      //       option1:o[0],
      //       option2:o[1] || null,
      //       option3:o[2] || null,
      //       inventory_quantity:0,
      //       available:false,
      //       bogus:true
      //     }
      //   )
      // });

      if (!el.variant) {

        if (_n3.default.urlparams.get('variant') && el.getAttribute('data-enable-history-state')) el.variant = el.product.variants.filter(function (v) {
          return v.id == _n3.default.urlparams.get('variant');
        })[0];

        if (!el.variant) el.variant = el.product.variants.filter(function (v) {
          return v.available;
        })[0];

        if (!el.variant) el.variant = el.product.variants[0];
      }

      el.variant.quantity = 1;

      _n3.default.trigger(el, 'product:init', false, true, el.variant);
      _n3.default.trigger(document, 'product:init', false, true, { el: el, variant: el.variant });

      _neptune2.default.debug.info('product:init', { el: el, variant: el.variant });

      if (!!el.product.image_constraint_options) {
        if (el.product.options_with_values.map(function (o) {
          return o.name;
        }).filter(function (v) {
          return el.product.image_constraint_options.includes(v);
        }).length) {
          _neptune2.default.product.constrain_images(el);
        }
      }

      el.properties = { _tags: el.product.tags };

      el.components = {};

      _neptune2.default.products.push({ el: el, product: el.product, variant: el.variant });

      _neptune2.default.product.refresh();
    });
  },

  refresh: function refresh() {
    _neptune2.default.liquid.load('ProductOptions');
  },

  option: function option(input) {

    if (!!input.getAttribute('neptune-option')) {
      var name = input.getAttribute('neptune-option');
    } else {
      var name = input.getAttribute('name').split('[')[1].split(']')[0];
    }

    var value = input.value;
    var el = _n3.default.parents(input, '[neptune-product]');

    el.product.options_with_values.map(function (option) {

      if (name == option.name) {
        option.selected = value;
      }
    });

    _n3.default.trigger(el, 'product:optionSelected', false, true, el.variant);
    _neptune2.default.debug.info('product:optionSelected', { el: el, variant: el.variant });

    _neptune2.default.product.variant.get(el, el.product.options_with_values.map(function (o) {
      return o.name;
    }).indexOf(name));
    _neptune2.default.liquid.load('ProductOptions');

    if (el.product.image_constraint_options.includes(name)) _neptune2.default.product.constrain_images(el);
  },

  variant: {
    get: function get(el, oi) {

      var options = _n3.default.qsa('select[neptune-option], [neptune-option]:checked', el).map(function (input) {
        return input.value.replace(/\"/g, '&quot;');
      });

      el.variant = el.product.variants.filter(function (v) {
        return _n3.default.equal(v.options, options);
      })[0];

      if (!el.variant) el.variant = {
        id: 0,
        options: options,
        option1: options[0] || null,
        option2: options[1] || null,
        option3: options[2] || null,
        price: el.product.variants[0].price,
        inventory_quantity: 0,
        available: false,
        bogus: true
      };

      el.variant.quantity = 1;

      _n3.default.trigger(el, 'product:variantSelected', false, true, el.variant);
      _n3.default.trigger(document, 'product:variantSelected', false, true, { el: el, variant: el.variant });
      _neptune2.default.debug.info('product:variantSelected', { el: el, variant: el.variant });

      if (el.getAttribute('data-enable-history-state')) {
        window.history.replaceState(window.history.state, document.title, document.location.pathname + '?' + _n3.default.urlparams.set('variant', el.variant.id));
      }

      return el.variant;
    },
    set: function set(el, id) {}
  },

  constrain_images: function constrain_images(el) {

    _n3.default.trigger(el, 'product:imageConstraint', false, true, el.variant);
    _neptune2.default.debug.info('product:imageConstraint', { el: el, variant: el.variant });

    if (!!_neptune2.default.liquid.topics.VariantImages) _neptune2.default.liquid.load('VariantImages');
  },

  quantity: {
    up: function up(input) {
      var el = _n3.default.parents(input, '[neptune-product]');
      if (el.variant.inventory_quantity > el.variant.quantity) el.variant.quantity++;
      _neptune2.default.liquid.load('ProductOptions');
      _n3.default.trigger(el, 'product:quantityChanged', false, true, el.variant);
      _neptune2.default.debug.info('product:quantityChanged', { el: el, variant: el.variant });
    },
    down: function down(input) {
      var el = _n3.default.parents(input, '[neptune-product]');
      if (el.variant.quantity > 1) el.variant.quantity--;
      _neptune2.default.liquid.load('ProductOptions');
      _n3.default.trigger(el, 'product:quantityChanged', false, true, el.variant);
      _neptune2.default.debug.info('product:quantityChanged', { el: el, variant: el.variant });
    }
  },

  addToCart: function addToCart(el) {

    if (_n3.default.parents(el, '[neptune-product]')) el = _n3.default.parents(el, '[neptune-product]');

    el = el || document;
    var items = [el].concat(_n3.default.array(_n3.default.qsa('[neptune-product]', el))).filter(function (el) {
      return !!el.product && el.variant;
    }).map(function (el) {
      return {
        id: parseInt(el.variant.id),
        quantity: el.variant.quantity,
        properties: el.properties
      };
    });

    if (!!el.components && Array.isArray(el.components)) items = items.concat(el.components);

    if (!!el.components && !Array.isArray(el.components) && (0, _typeof3.default)(el.components) == 'object') items = items.concat(Object.values(el.components));

    items = items.map(function (item) {
      return {
        id: parseInt(item.id || item),
        quantity: item.quantity || 1,
        properties: item.properties || {}
      };
    });

    if (!!el.components && !!el.instance) {
      items = items.map(function (item) {
        item.properties._instance = el.instance;
        return item;
      });
    }

    el.instance = _n3.default.random(15);

    items = items.filter(function (item) {
      return !!item.id;
    });

    return _neptune2.default.cart.add(items);
  }

};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.product;